<template>
  <div id="container">
    <div class="navbar">
      <img :src="logoImg" alt class="float-left" height="60px"/>
    </div>
    <div class="info">
      <div class="info-img">
        <img :src="docPic" alt height="120px"/>
        <p style="font-size:18px">医生注册</p>
      </div>
      <!-- <back-btn @myClose="goBack"></back-btn> -->
      <div class="info-title">登录信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="right"
        label-width="200px"
        class="info-form"
      >
        <el-form-item label="手机号码" prop="mobile" class="ipt-item">
          <el-input v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="手机验证码" prop="rectify" class="ipt-item">
          <!-- <el-input type="password" style="display:inline-block;width:77%"  v-model="ruleForm.rectify" placeholder="请输入密码/验证码" show-password clearable></el-input>
          <el-button type="default" size="medium" >获取验证码</el-button> -->
          <el-input placeholder="请输入内容" v-model="ruleForm.rectify" class="input-with-select">
            <el-button slot="append" type="default" size="medium" @click="getVerificationCode" :disabled="verCodeDisable">{{timeText}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="密码" prop="newPassword" class="ipt-item">
          <el-input v-model="ruleForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword" class="ipt-item">
          <el-input v-model="ruleForm.confirmPassword" show-password></el-input>
        </el-form-item>
      </el-form>

      <div class="info-title">账号信息</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-position="right"
        label-width="200px"
        class="info-form"
      >
        <el-form-item label="姓名" prop="mobile" class="ipt-item">
          <el-input v-model="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="rectify" class="ipt-item">
          <el-input v-model="ruleForm.rectify"></el-input>
        </el-form-item>
        <el-form-item label="所属医院" prop="newPassword" class="ipt-item">
          <el-input v-model="ruleForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="所属科室" prop="confirmPassword" class="ipt-item">
          <el-input v-model="ruleForm.confirmPassword" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="checked">
            我已阅读并接受
            <a style="font-size:14px">《卡易远程医疗协同平用户服务协议》</a>
          </el-checkbox>
        </el-form-item>
      </el-form>
      <div class="info-bottom">
        <el-button type="primary" class="info-btn" @click="changePassword">确认</el-button>
        <el-button type="default" class="info-btn" @click="goBack">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
// import Logo from '../../../examples/assets/images/logo-light.png'
// import DocPic from '../../../examples/assets/images/doctor_lg.png'

export default {
  name:'kyRegister',
  props:{
    logoImg:{
        String,
        default:require('../../../examples/assets/images/logo-light.png')
    },
    docPic:{
        String,
        default:require('../../../examples/assets/images/doctor_lg.png')
    }
  },
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value.length <= 5) {
        callback(new Error('密码需要大于5位'))
      } else {
        callback()
      }
    }
    var validateRepassword = (rule, value, callback) => {
      if (value != this.ruleForm.newPassword) {
        callback(new Error('密码不一致'))
      } else {
        callback()
      }
    }
    return {
    //   logo: Logo,
    //   docPic: DocPic,
      // pwdChange:false,
      ruleForm: {
        mobile: '', // 新密码
        rectify: '', // 验证码
        confirmPassword: '', // 再次新密码
        oldPassword: '' // 原密码
      },
      rules: {
        mobile: [
          { required: true, trigger: 'blur', message: '请输入手机号码！' }
        ],
        rectify: [
          { required: true, trigger: 'blur', message: '请输入手机验证码！' }
        ],
        oldPassword: [
          { required: true, trigger: 'blur', message: '请输入密码！', validator: validatePassword }
        ],
        // newPassword: [
        //   { required: true, trigger: 'blur', message: '请输入新密码！', validator: validatePassword }
        // ],
        confirmPassword: [
          { required: true, trigger: 'blur', message: '请再次输入密码！', validator: validateRepassword }
        ]
      },
      checked: false,
      timeText: '获取验证码'
    }
  },
  computed: {
    verCodeDisable() {
      let val = this.ruleForm.mobile
      if (val == '') {
        return true
      }
      let phoneFlag = true
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!myreg.test(val)) {
        phoneFlag = false
      }
      return !phoneFlag || this.timeText !== '获取验证码'
    }
  },
  methods: {
    changePassword() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('submit',this.ruleForm);
        }
      })
    },
    resetRuleForm() {
      this.ruleForm = {
        newPassword: '', // 新密码
        confirmPassword: '', // 再次新密码
        oldPassword: '' // 原密码
      }
    },
    getVerificationCode() {
      /* 获取验证码 */
      this.$emit('sendSMS',this.ruleForm.mobile);
      // verificationCodeSMS({ username: this.ruleForm.mobile })
      let time = 60
      let inter = setInterval(() => {
        time--
        this.timeText = `重新获取(${time})`
        this.$forceUpdate()
      }, 1000)
      setTimeout(() => {
        clearInterval(inter)
        this.timeText = '获取验证码'
      }, 60000)
    },
    goBack(){
      this.$emit('goBack')
    }
  }
}
</script>

<style lang="scss" scoped>
$bg: #31414f;
#container {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  background-color: $bg;
}
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background-color: #061528;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.info {
  margin: 100px 120px;
  position: relative;
  background: #fff;
  border-radius: 7px;
  padding: 15px 0px 0px;
  .info-img {
    text-align: center;
    margin-top: -86px;
  }
  .info-title {
    margin: 20px 40px;
    padding-left: 15px;
    height: 40px;
    line-height: 40px;
    background-color: #f2f2f2;
  }
  .info-form {
    width: 75%;
    padding: 30px 0;
    padding-left: 15%;
  }
  .info-bottom {
    background-color: #f5f5f5;
    text-align: center;
    padding: 15px;
    .info-btn {
      width: 120px;
      margin-right: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// packages/register/src/Register.vue